export default "__VITE_ASSET__BFy02d9M__"